module.exports = __webpack_public_path__ + "static/media/faiez.c7592085.png";